var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBehanceOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.288 7.29h-4.606v1.375h4.606V7.291z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.809 17.796s3.545.113 3.545-3.295c0 0 .155-2.771-2.09-2.771 0 0 1.703-.128 1.703-2.125 0-1.997-1.393-2.972-3.158-2.972H3v11.163h5.809zm0-4.967H5.56v2.984h3.086c.463-.01 1.34-.146 1.34-1.45 0-1.55-1.176-1.534-1.176-1.534zm0-4.211s.79 0 .79 1.16c0 1.161-.465 1.33-.991 1.33H5.559v-2.49h3.25zm6.376 5.701h5.785s.632-4.845-3.886-4.845c-4.293 0-4.289 4.288-4.289 4.288s-.295 4.268 4.289 4.268c0 0 3.82.218 3.82-2.97H18.94s.065 1.202-1.79 1.202c0 0-1.964.13-1.964-1.943zm-.024-1.49s.24-1.721 1.964-1.721c1.725 0 1.702 1.721 1.702 1.721H15.16z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehanceOutline);
export default __webpack_public_path__ + "3859c14f3081bc53a47e6dde7cd371bd.svg";
export { ForwardRef as ReactComponent };